import React, { useState, useEffect } from 'react'
import Layout from '../../../../component/layout/Layout'
import 'aos/dist/aos.css';
import AOS from 'aos';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import firebaseConfig from '../../../firebase/firebaseConfig';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();

const Sugar = () => {

    const [activeSlide, setActiveSlide] = useState(0);

    const handleSlideChange = (index) => {
        setActiveSlide(index);
    };


    const [cards, setCards] = useState([]);

    useEffect(() => {
        AOS.init({ duration: 1000 });

        // Fetch card data ordered by orderID
        const fetchCards = async () => {
            try {
                const snapshot = await db
                    .collection("sugar_specialitychem")
                    .orderBy("orderID", "asc") // Order by 'orderID' in ascending order
                    .get();

                const cardData = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setCards(cardData);
            } catch (error) {
                console.error("Error fetching cards: ", error);
            }
        };

        fetchCards();
    }, []);

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/specialalitychem">Speciality Chemicals</a></li>
                    <li><a href="/">Home</a></li>
                </ul>
            </div>
            <section id="hero">
                <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-interval="5000" data-bs-ride="carousel">
                    <ol className="carousel-indicators" id="hero-carousel-indicators">
                        <li
                            data-bs-target="#heroCarousel"
                            data-bs-slide-to="0"
                            className={activeSlide === 0 ? "active" : ""}
                            onClick={() => handleSlideChange(0)}
                        ></li>
                    </ol>
                    <div className="carousel-inner" role="listbox">
                        <div className={`carousel-item ${activeSlide === 0 ? "active" : ""}`} style={{ backgroundImage: "url(/img/sugar-industry-cover-300x169.jpg)" }}>
                            <div className="carousel-container">
                                <div className="container">
                                    <div className="text" id='text'>
                                        <h2 className="animate__animated animate__fadeInDown">Sugar</h2>
                                        <p className="animate__animated animate__fadeInUp">e have experties in manufacturing water soluble polymers for sugar segment. Our product basket offers chemical solutions that result in better color, higher yields and improved efficiency in the sugar industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <div className="table-responsive">
                <table className="table table-bordered table-striped ">
                    <thead className="thead table-dark">
                        <tr>
                            <th scope="col">Applications</th>
                            <th scope="col">RISHLYTE
                                Coagulants</th>
                            <th scope="col">RISHFLOC
                                Flocculants</th>
                            <th>RISHICIDE
                                Biocides</th>
                            <th>RISHFOAM
                                Defoamer</th>
                            <th>RISHLYTE
                                Antiscalent /
                                Viscosity Modifiers</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Sugar Cane / Beet Juicer</th>
                            <th></th>
                            <td></td>
                            <td>&#10004;</td>
                            <td>&#10004;</td>
                            <td></td>

                        </tr>
                        <tr>
                            <th scope="row">Juice Liming</th>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>&#10004;</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th scope="row">Juice Clarification</th>
                            <td>&#10004;</td>
                            <td>&#10004;</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Mill Sanitation</th>
                            <td></td>
                            <td></td>
                            <td>&#10004;</td>
                            <td></td>
                            <td></td>

                        </tr>
                        <tr>
                            <th>Pan Additives</th>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>&#10004;</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Sugar Refining</th>
                            <td>&#10004;</td>
                            <td>&#10004;</td>
                            <td></td>
                            <td></td>
                            <td>&#10004;</td>


                        </tr>
                        <tr>
                            <th>Molasses Distillery</th>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>&#10004;</td>
                            <td>&#10004;</td>
                        </tr>
                        <tr>
                            <th>Effluent Treatment</th>
                            <td>&#10004;</td>
                            <td>&#10004;</td>
                            <td></td>
                            <td></td>
                            <td>&#10004;</td>
                        </tr>

                        <tr>
                            <th>Juice Evaporation</th>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>&#10004;</td>
                            <td></td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <br />
            <section id="services" className="services">
                <div className="container" data-aos="fade-up">
                    <div className="row">
                        {cards.map((card, index) => (
                            <div
                                key={card.id}
                                className="col-lg-4 col-md-6"
                                data-aos="zoom-in"
                                data-aos-delay={100 * (index + 1)}
                            >
                                <div className="icon-box">
                                    <h4>{card.title}</h4>
                                    <p>{card.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Layout >
    )
}

export default Sugar
